<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Título" :required="true" v-model="form.title"
						:value="form.title"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Texto</label>
						<div class="col-sm-9">
							<editor v-model="form.content" style="height: 280px">
								<editor-tool :name="'formatting'"></editor-tool>
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'fontSize'"></editor-tool>
								<editor-tool :name="'foreColor'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'indent'"></editor-tool>
								<editor-tool :name="'outdent'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.active" :value="form.active" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActive"></footer-button>
		</form>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

import '@progress/kendo-ui'
import '@progress/kendo-ui/css/web/kendo.default-v2.min.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

// eslint-disable-next-line no-undef
kendo.culture('pt-BR')
Vue.use(EditorInstaller)

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		Editor,
		EditorTool,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Páginas',
			form: {
				title: '',
				content: '',
				active: '1'
			},
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				await req(`/paginas/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/paginas')
			} else {
				await req('/paginas', 'post', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/paginas')
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/paginas/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.active = resp.active
			this.form.title = resp.title
			this.form.content = resp.content
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
